module.exports = __webpack_public_path__ + "static/img/goods-1.bdbba007.png";